import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fw-500 fs-19px text-white" }

interface IProps {
  disable?: boolean
  price?: string
  icon?: string
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KBillButton' },
  __name: 'KBillButton',
  props: {
    disable: { type: Boolean, default: false },
    price: { default: '' },
    icon: { default: '' }
  },
  emits: ['hold', 'send', 'pay'],
  setup(__props: any) {







return (_ctx: any,_cache: any) => {
  const _component_KCheckoutButton = _resolveComponent("KCheckoutButton")!
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["k-bill-button bg-off-white-20 q-pa-sm rounded-24 flex flex-center no-wrap gap-sm", { 'k-bill-button--disable': __props.disable }])
  }, [
    _createVNode(_component_KCheckoutButton, {
      title: "Hold",
      icon: "hold",
      size: "sm",
      disable: __props.disable,
      class: "transition",
      onAction: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hold')))
    }, null, 8, ["disable"]),
    _createVNode(_component_KCheckoutButton, {
      title: "Send",
      size: "sm",
      disable: __props.disable,
      class: "transition",
      onAction: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('send')))
    }, {
      icon: _withCtx(() => [
        (__props.disable)
          ? (_openBlock(), _createBlock(_component_KIcon, {
              key: 0,
              name: "order-cook-disabled",
              size: "32px",
              class: "k-bill-button__icon--disabled"
            }))
          : _renderSlot(_ctx.$slots, "icon", { key: 1 }, () => [
              _createVNode(_component_KIcon, {
                name: __props.icon,
                size: "32px",
                color: __props.disable ? 'cool-gray-60' : 'cool-gray-100'
              }, null, 8, ["name", "color"])
            ])
      ]),
      _: 3
    }, 8, ["disable"]),
    _createElementVNode("div", {
      class: _normalizeClass(["k-bill-button__payment flex rounded-16 cursor-pointer no-wrap transition shadow-1", { 'k-bill-button--disable': __props.disable }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('pay')))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["k-bill-button__payment--left flex flex-center column gap-xs q-px-md transition", [__props.disable ? 'k-bill-button__payment-left-disable bg-static-light' : 'bg-white']])
      }, [
        _createVNode(_component_KIcon, {
          name: "checkout-pay",
          size: "32px",
          color: __props.disable ? 'cool-gray-60' : 'cool-gray-100'
        }, null, 8, ["color"]),
        _createElementVNode("span", {
          class: _normalizeClass(["fw-500 fs-15px transition", [__props.disable ? 'text-cool-gray-60' : 'text-cool-gray-100']])
        }, " Pay ", 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["k-bill-button__payment--right bg-space-b-xd flex flex-center transition", { 'bg-cool-gray-50': __props.disable }])
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(__props.price), 1)
      ], 2)
    ], 2)
  ], 2))
}
}

})